<template>
  <div class="min-h-screen">
    <AppNavbar />
    
    <main class="page-gutter pt-32 pb-20">
      <article class="max-w-4xl mx-auto card">
        <header class="mb-8 pb-6 border-b border-border">
          <h1 class="text-4xl sm:text-5xl font-extrabold mb-4 flex items-center gap-3">
            <svg class="w-10 h-10 text-primary-500" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M17.13,17C15.92,18.85 14.11,20.24 12,20.92C9.89,20.24 8.08,18.85 6.87,17C6.53,16.5 6.24,16 6,15.47C6,13.82 8.71,12.47 12,12.47C15.29,12.47 18,13.79 18,15.47C17.76,16 17.47,16.5 17.13,17Z"/>
            </svg>
            <span class="gradient-text">Privacy Policy</span>
        </h1>
          <p class="text-muted text-sm">Last updated: July 10, 2025</p>
        </header>

        <section class="space-y-6 text-muted prose prose-invert max-w-none">
        <p>
            This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
        </p>
        <p>
            We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the
            <a href="https://www.termsfeed.com/privacy-policy-generator/" target="_blank" rel="noopener noreferrer" class="text-primary-400 hover:text-primary-300 underline">Privacy Policy Generator</a>.
          </p>

          <div class="mt-10">
            <h2 class="text-2xl font-bold text-text mb-4">Interpretation and Definitions</h2>
            <h3 class="text-xl font-semibold text-text mb-3">Interpretation</h3>
            <p>
              The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
            </p>

            <h3 class="text-xl font-semibold text-text mb-3 mt-6">Definitions</h3>
        <p>For the purposes of this Privacy Policy:</p>
            <ul class="list-disc list-inside space-y-2 ml-4">
              <li><strong class="text-primary-400">Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
              <li><strong class="text-primary-400">Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</li>
              <li><strong class="text-primary-400">Application</strong> refers to App to Link, the software program provided by the Company.</li>
              <li><strong class="text-primary-400">Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Lokum Ops FZE, Business Centre, Sharjah Publishing City Free Zone, Sharjah, United Arab Emirates.</li>
              <li><strong class="text-primary-400">Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
              <li><strong class="text-primary-400">Country</strong> refers to: United Arab Emirates</li>
              <li><strong class="text-primary-400">Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
              <li><strong class="text-primary-400">Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
              <li><strong class="text-primary-400">Service</strong> refers to the Application or the Website or both.</li>
              <li><strong class="text-primary-400">Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company.</li>
              <li><strong class="text-primary-400">Third-party Social Media Service</strong> refers to any website or any social network website through which a User can log in or create an account to use the Service.</li>
              <li><strong class="text-primary-400">Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself.</li>
              <li><strong class="text-primary-400">Website</strong> refers to App to Link, accessible from <a href="https://apptolink.com" rel="external nofollow noopener" target="_blank" class="text-primary-400 hover:text-primary-300 underline">https://apptolink.com</a></li>
              <li><strong class="text-primary-400">You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
        </ul>
          </div>

          <div class="mt-10">
            <h2 class="text-2xl font-bold text-text mb-4">Collecting and Using Your Personal Data</h2>
            <h3 class="text-xl font-semibold text-text mb-3">Types of Data Collected</h3>
            
            <h4 class="text-lg font-semibold text-text mb-2">Personal Data</h4>
            <p>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</p>
            <ul class="list-disc list-inside space-y-2 ml-4">
              <li>Email address</li>
              <li>First name and last name</li>
              <li>Usage Data</li>
        </ul>

            <h4 class="text-lg font-semibold text-text mb-2 mt-6">Usage Data</h4>
        <p>Usage Data is collected automatically when using the Service.</p>
            <p>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
          </div>

          <div class="mt-10">
            <h2 class="text-2xl font-bold text-text mb-4">Children's Privacy</h2>
            <p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us.</p>
          </div>

          <div class="mt-10">
            <h2 class="text-2xl font-bold text-text mb-4">Links to Other Websites</h2>
            <p>Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.</p>
          </div>

          <div class="mt-10">
            <h2 class="text-2xl font-bold text-text mb-4">Changes to this Privacy Policy</h2>
            <p>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.</p>
            <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
          </div>

          <div class="mt-10">
            <h2 class="text-2xl font-bold text-text mb-4">Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, You can contact us:</p>
            <ul class="list-disc list-inside space-y-2 ml-4">
              <li>By email: <a :href="infoMailto" class="text-primary-400 hover:text-primary-300 underline">{{ infoEmail }}</a></li>
              <li>By visiting this page on our website: <a href="https://apptolink.com" rel="external nofollow noopener" target="_blank" class="text-primary-400 hover:text-primary-300 underline">https://apptolink.com</a></li>
        </ul>
          </div>
      </section>
      </article>
    </main>

    <!-- Footer -->
    <footer class="page-gutter py-8 border-t border-border">
      <div class="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p class="text-muted text-sm">&copy; 2024 App to Link. All rights reserved.</p>
        <nav class="flex items-center gap-6 text-sm text-muted">
          <router-link to="/" class="hover:text-text transition">Home</router-link>
          <router-link to="/privacy-policy" class="hover:text-text transition">Privacy Policy</router-link>
          <router-link to="/terms-of-service" class="hover:text-text transition">Terms of Service</router-link>
          <router-link to="/data-deletion" class="hover:text-text transition">Data Deletion</router-link>
          <a :href="infoMailto" class="hover:text-text transition">Contact</a>
        </nav>
      </div>
    </footer>
  </div>
</template>

<script>
import AppNavbar from './AppNavbar.vue';
import emailObfuscation from '@/mixins/emailObfuscation';

export default {
  name: 'PrivacyPolicy',
  components: { AppNavbar },
  mixins: [emailObfuscation]
}
</script>

